module.exports = __webpack_public_path__ + "img/blog-1.4aecc4df.webp";